import { NavLink, NavLinkProps } from 'react-router-dom'
import { RainbowKitCustomButton } from '../RainbowKitCustomButton'
import { useActiveLink } from '@/hooks/useActiveLink.ts'
import React from 'react'
import External from '@/assets/icons/External.svg?react'
import { SHOW_ANNOUNCEMENT_BAR } from '@/config/constants.ts'

const NavLinks = ({ isActive, ...props }: { isActive: boolean } & NavLinkProps) => (
	<NavLink
		{...props}
		className={
			(isActive ? 'border-b-2 text-danger font-bold' : 'text-secondary') +
			' text-[1.5rem] max-w-fit border-danger'
		}
	/>
)

const DesktopMenu = ({ links }) => {
	const { isActiveLink } = useActiveLink(links)

	return (
		<div
			style={{ top: SHOW_ANNOUNCEMENT_BAR ? 'calc(var(--announcement-h, 2.5rem) + 8px)' : '8px' }}
			className="fixed left-[50%] translate-x-[-50%] h-[61px] bg-neutral flex justify-between items-center rounded-full px-6 z-50 w-[98%] drop-shadow-lg"
		>
			<div className="flex justify-between items-center gap-6">
				{links.map(link =>
					link?.external ? (
						<div className="relative">
							<a
								key={link.label}
								target="_blank"
								href={link.label}
								className="text-[1.5rem] max-w-fit border-danger text-secondary pr-6"
								data-testid={link.testId}
							>
								{link.label}
							</a>
							<External className="absolute right-1 top-1/2 -translate-y-1/2 w-[1rem]" />
						</div>
					) : (
						<NavLinks
							key={link.label}
							to={link.link}
							isActive={isActiveLink(link.link)}
							data-testid={link.testId}
						>
							{link.label}
						</NavLinks>
					)
				)}
			</div>
			<div className="absolute top-3 left-[50%] translate-x-[-50%]">
				<img src="/images/pepper-logo.webp" alt="logo" className="w-[80px] aspect-square" />
			</div>
			<div className="flex items-center gap-3">
				<RainbowKitCustomButton />
			</div>
		</div>
	)
}

export default DesktopMenu
